import React, { useRef } from "react";

import { __t } from "../../utils/translate";
import { Product } from "../../utils/types";

import Coupon from "@/components/product/coupon";
import ProductAddToCart from "@/components/product/productAddToCart";
import { useProductContext } from "@/providers/productProvider";
import { printPrice } from "@/utils/utils";

type ProductOptionsProps = {
    product: Product;
    className: string;
    attributesBundle: { products: Record<string, Product>; };
    setAttributeBundle: (attribute: any) => void;
};

export const getPrices = (product: Product, variationId: number) => {
    if (product.variations_product.length === 0) {
        return {
            sale_price: product.sale_price ? printPrice(product.sale_price) : false,
            regular_price: printPrice(product.regular_price)
        }
    }

    const variation = product.variations_product.find(v => v.id === variationId);

    if (variation) {
        return {
            sale_price: variation.sale_price ? printPrice(variation.sale_price) : false,
            regular_price: printPrice(variation.regular_price)
        }
    } else {
        const firstVariation = product.variations_product[0];
        return {
            sale_price: firstVariation.sale_price ? printPrice(firstVariation.sale_price) : false,
            regular_price: printPrice(firstVariation.regular_price),
        }
    }
}

const ProductOptions: React.FC<ProductOptionsProps> = ({
    product,
    attributesBundle,
    setAttributeBundle,
}) => {
    const scrollRef = useRef()

    const { variationId } = useProductContext();
    const prices = getPrices(product, variationId);

    function handleScroll() {
        scrollRef.current.scrollIntoView({ behavior: 'smooth' })
    }

    return (
        <div ref={scrollRef}>
            <ProductAddToCart
                product={product}
                prices={prices}
                attributesBundle={attributesBundle}
                setAttributeBundle={setAttributeBundle}
                isCoupon={false}
                className={"overflow-visible"}
            />
            <Coupon
                product={product}
                prices={prices}
                attributesBundle={attributesBundle}
                setAttributeBundle={setAttributeBundle}
                handleScroll={() => handleScroll()}
            />
        </div>
    )
}

export default ProductOptions;